import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3da4e430"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-carousel" }

import { storeToRefs } from 'pinia';
import { useHome, useMedia } from '@/store';
import Swiper from '@/components/base/Swiper.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BottomCarousel',
  setup(__props) {

const { bottomCarouselInfo } = storeToRefs(useHome());
const { player } = storeToRefs(useMedia());
const {
  updateIsEnlarged,
  updateYoutube,
  updateYoutubeCover,
  updatePlayerState,
} = useMedia();
const playVideo = (videoId: string) => {
  updateIsEnlarged(true);
  updateYoutubeCover(`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`);
  try {
    player.value.playVideo();
  } catch (err) {
    updatePlayerState('cued');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Swiper, {
      list: _unref(bottomCarouselInfo),
      type: 'images',
      slidesPerView: 'auto',
      spaceBetween: 20,
      grabCursor: true,
      onUpdateYoutube: _unref(updateYoutube),
      onPlayVideo: playVideo
    }, null, 8, ["list", "onUpdateYoutube"])
  ]))
}
}

})